<template>
    <div class="floor" v-if="floorConfig.validated">
        <!-- 楼层标题 -->
        <div class="floor_title">
            <div class="floor_title_content">
                <span class="floor_title_border"
                    :style="{ 'background-color': floorConfig.curr.title.value.color }"></span>
                <span class="floor_title_content_index" :style="{ color: floorConfig.curr.title.value.color }">{{
                    floorConfig.curr.title.value.text || "1F" }}</span>
                <!-- <span class="floor_title_content_text">{{ floorConfig.curr.subTitle.value.text || "NiuShop" }}</span> -->
            </div>

            <div class="other-title">
                <!-- <router-link :to="{ path: '/list', query: { category_id: 124, level: 1 } }"
                    target="_blank">更多</router-link> -->
            </div>
        </div>
        <!-- 楼层内容区 -->
        <div>
            <div class="floor_content">
                <!-- 左侧区域 -->
                <!-- <div class="floor_content_left" style="display: block;"> -->
                <!-- 左侧左区1/3长图片区 -->
                <!-- <div class="narrow">
                        <div @click="handleLinkClick(floorConfig.curr.leftImg.value.link.url)" class="narrow-sec-wrap">
                            <el-image v-if="floorConfig.curr.leftImg.value"
                                :src="$img(floorConfig.curr.leftImg.value.url)" fit="cover" />
                        </div> -->

                <!-- 超链接区 -->
                <!-- <div class="narrow_link" v-if="floorConfig.curr.leftImg.value.link">
                        <div v-for="(item, index) in floorConfig.curr.leftImg.value" :key="index" @click="handleLinkClick(item.url)">
                            <el-link>aaaaaa{{ item.displayName }}</el-link>
                        </div>
                    </div> -->
                <!-- </div> -->
                <!-- <div class="wide">
                    <el-carousel :interval="3000" height="500px" indicator-position="none">
                        <el-carousel-item v-for="(item, index) in floorConfig.leftRightImages" :key="index">
                            <div class="wide-four-wrap" @click="handleLeftRightClick(item.url)">
                                <el-image v-if="item.image" :src="$img(item.image) || $img(defaultGoodsImage)" fit="cover" />
                            </div>
                        </el-carousel-item>
                    </el-carousel>

                    超链接区
                    <div class="wide_link" v-if="brandList.length">
                        <div v-for="item in brandList" :key="item.brand_id" @click="handleBrandClick(item.brand_id)">
                            <el-card class="card" body-style="padding:1px;width:100%;height:100%;box-sizing: border-box;" shadow="hover">
                            <el-image :src="$img(item.image_url)" fit="cover" @error="item.image_url = defaultGoodsImage" />
                            </el-card>
                        </div>
                    </div>
                </div> -->
                <!-- </div> -->

                <!-- 右侧区域 -->
                <div class="floor_content_right">
                    <cargo-item :cargo="item" v-for="(item, index) in skuList" :key="index" />
                    <div style="width:20.3%;" v-for="item in 4 - skuList.length % 4"></div>
                </div>

            </div>
            <!-- 底部区域 -->
            <!-- <div class="narrow" style="margin-top: 20px;width: 100%;height: 118px;">
                <div @click="handleLinkClick(floorConfig.curr.bottomImg.value.link.url)" style="height:118px">
                    <el-image v-if="floorConfig.curr.bottomImg.value" :src="$img(floorConfig.curr.bottomImg.value.url)"
                        fit="cover" style="width: 100%;height: 100%;"/>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import CargoNormal from "@/components/cargo/CargoNormal"
import CargoItem from "./cargo_item_1"
import { brandSimpleList, goodsSkuList } from "../../../api/goods/goods"

export default {
    name: "style1",
    components: {
        CargoNormal,
        CargoItem
    },
    props: {
        config: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            display: "",
            floorConfig: {
                validated: false,
                rightCargos: [],
                leftLeftImage: {},
                leftLeftLinks: [],
                leftRightBrands: [],
                leftRightImages: []
            },
            brandList: [],
            skuList: []
        }
    },
    created() {
        this.$store.dispatch("site/defaultFiles")
        this.getBrandList()
        this.getSkuList()

    },
    computed: {
        ...mapGetters(["defaultGoodsImage"])
    },
    methods: {
        handleBrandClick(brandId) {
            if (brandId) {
                this.$router.pushToTab(`list?brand_id=${brandId}`)
            }
        },
        handleLinkClick(url) {
            if (url) {
                this.$router.pushToTab(`${url}`)
            }
        },
        handleLeftRightClick(url) {
            if (url) {
                this.$router.pushToTab(`${url}`)
            }
        },
        getBrandList() {
            brandSimpleList({ brand_ids: this.floorConfig.leftRightBrands })
                .then((res) => {
                    this.brandList = res.data
                })
                .catch((err) => { })
        },
        getSkuList() {

            console.log(this.floorConfig.curr)
            let sku_ids = this.floorConfig.curr.goodsList.value.sku_ids
            sku_ids = "2699,2700,2701,2702,2703,2704,2705,2706,2707,2708,2709,2710,2711,2712,2713"
            // .map(item => {
            //     return item.sku_id
            // })
            // .toString()
            goodsSkuList({ sku_ids })
                .then((res) => {
                    this.skuList = res.data
                })
                .catch((err) => { })
        }
    },
    watch: {
        config: {
            handler: function (curr) {
                console.log(this.floorConfig)
                console.log(565656)
                console.log(curr)
                if (curr && curr.goodsList && curr.bottomImg && curr.title) {
                    console.log(1111111111111)
                    this.floorConfig.curr = curr
                    console.log('this.floorConfig.curr', this.floorConfig.curr)
                    this.floorConfig.validated = true
                    // this.floorConfig = { ...curr, validated: true }
                }
                // this.floorConfig.curr.title=JSON.parse(this.floorConfig.curr.title)

                // console.log(this.floorConfig.curr.bottomImg.value.url)
            },
            immediate: true,
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.floor {
    &_title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 20px;

        &_border {
            display: inline-block;
            width: 5px;
            height: 28px;
            background-color: $base-color;
            margin-right: 12px;
            vertical-align: top;
        }

        &_content {
            font-size: 20px;
            padding-top: 10px;
            padding-bottom: 10px;
            height: 48px;
            line-height: 28px;
            // border-bottom: 1px solid transparentize($color: $ns-text-color-black, $amount: 0.9);
            box-sizing: border-box;

            &_index {
                display: inline-block;
                color: $ns-text-color-black;
                padding-right: 8px;
                font-weight: 600;
            }

            &_text {
                font-weight: 600;
                display: inline-block;
                color: $base-color;
            }
        }
    }

    .other-title {
        a {
            color: #838383;

            i {
                font-size: 14px;
            }

            &:hover {
                color: $base-color;
            }
        }
    }

    &_content {
        display: flex;
        width: 100%;
        // height: 500px;

        &_left {
            // width: 19%;
            width: 234px;
            display: inline-flex;
            margin-right: 5px;

            .narrow {
                width: 100%;
                position: relative;

                .el-image {
                    width: 100%;
                    height: 100%;
                    z-index: 100;
                }

                .narrow_link {
                    z-index: 110;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    // background-color: transparentize($ns-text-color-black, 0.7);
                    background-color: rgba(0, 0, 0, 0.1);
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    justify-content: space-around;
                    padding: 10px 0;

                    .el-link {
                        opacity: 1;
                        color: white;
                    }
                }
            }

            .wide {
                width: 65%;
                position: relative;

                .el-carousel {
                    z-index: 100;
                }

                .wide_link {
                    display: flex;
                    flex-direction: row;
                    position: absolute;
                    justify-content: center;
                    bottom: 10px;
                    left: 10px;
                    right: 10px;
                    // width: 100%;
                    flex-wrap: wrap;
                    z-index: 110;
                    // padding: 10px 0;
                    // background-color: transparentize($ns-text-color-black, 0.7);
                    opacity: 0.9;
                    cursor: pointer;

                    >div {
                        width: calc(25% - 2px);
                        height: 50px;
                        margin-left: 1px;
                        margin-right: 1px;
                        margin-bottom: 1px;
                        background: #ffffff;
                        opacity: 0.9;
                    }

                    .el-image {
                        width: 100%;
                        height: 100%;
                    }

                    .card {
                        width: 100%;
                        height: 100%;
                        border-radius: 0;
                        border: none;

                        // &:hover {
                        //     box-shadow: 0 2px 4px transparentize($color: $base-color-info, $amount: 0.3), 0 0 6px transparentize($color: $base-color-info, $amount: 0.4);
                        // }
                    }
                }
            }

            .narrow-sec-wrap,
            .wide-four-wrap {
                height: 100%;
                width: 100%;

                .el-image {
                    height: 100%;
                    width: 100%;
                    cursor: pointer;
                }
            }
        }

        &_right {
            // width: 81%;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-around;
            align-content: space-between;
            cursor: pointer;

            .item {
                width: 19.3%;
                height: 60%;
                border-radius: 0;
                text-align: center;
                background-color: #ffffff;
                border: 1px solid #e9e9e9;
                border-top: none;
                border-left: none;
                box-sizing: border-box;

                &:nth-child(-n + 3) {
                    border-top: 1px solid #e9e9e9;
                }

                &_image {
                    height: 177px;
                    margin: 10px;

                    .el-image {
                        width: 100%;
                        height: 100%;
                    }
                }

                &_cargo_name {
                    height: 25px;
                    margin: auto 10px;
                    color: $base-color;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                &_cargo_desc {
                    font-size: $ns-font-size-sm;
                    margin: auto 10px;
                    height: 25px;
                    color: $base-color-info;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
    }
}
</style>